var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"spectrum-Tool",attrs:{"aria-label":_vm.label}},[_c('Icon',{attrs:{"name":_vm.iconName,"size":_vm.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }